// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"1dcc28c6","378":"5cfab4ad","626":"1f46a14a"}[chunkId] + ".chunk.js";
};